import React from 'react'
import { Helmet } from 'react-helmet'
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import BrandLogoSlider from '../../components/BrandLogoSlider'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import MyInvoiceDetails from '../../components/MyInvoiceDetails'

function InvoiceDetailsPage() {
    return (
        <>
            <Helmet>
                <title>Order Details</title>
            </Helmet>
            <Header />
            <ActiveCatalogue />
            <MyInvoiceDetails />
            <BrandLogoSlider />
            <Footer displayFooterTop={false} />
        </>
    )
}

export default InvoiceDetailsPage;

